<template>

  <rate-calendar-bar
    :calendar-type="calendarType"
    :title="title"
  >

    <template v-slot:extras>
      <p>{{ costRange }}</p>
    </template>

  </rate-calendar-bar>

</template>

<script setup lang="ts">

import { computed } from 'vue'
import RateCalendarBar from './RateCalendarBar.vue'
import type { EventBaseItem } from '../types'
import { currencyFormatter } from '../../../../../utils/formatters'

interface Props {
  item: EventBaseItem
  calendarType: string
}

const props = defineProps<Props>()

const title = computed<string>(() => {
  if (props.calendarType === 'month') {
    return `${productName.value} ${costRange.value}`
  } else {
    return productName.value
  }

})

const productName = computed<string>(() => {
  return props.item.locationProduct?.product?.name ?? '(unknown product)'
})

const costs = computed<number[]>(() => {
  const output: number[] = []
  props.item.locationProduct.venueLocationProducts.forEach(vlp => {
    vlp.venueTiers.forEach(venueTier => {
      output.push(venueTier.tierPrice)
    })
  })
  return output.toSorted((c1, c2) => c1 - c2)
})

const lowestCost = computed<null | number>(() => {
  return costs.value.at(0) ?? null
})

const highestCost = computed<null | number>(() => {
  return costs.value.at(-1) ?? null
})

const costRange = computed<string>(() => {
  if (lowestCost.value === null || highestCost.value === null) {
    return ''
  } else if (lowestCost.value === highestCost.value) {
    return currencyFormatter.format(lowestCost.value)
  } else {
    return `${currencyFormatter.format(lowestCost.value)} – ${currencyFormatter.format(highestCost.value)}`
  }
})

</script>
